// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__hThJM","footer":"ModalInfo_footer__1mjPp"};